export default {
    sessions: {
        create: {
            titleLive: 'Plan New Meditation',
            titleRecorded: 'Add Recorded Meditation',
            titleMindfulMinute: 'Add Mindful Moment',
            successMessage: 'New Meditation has been added'
        },
        view: {
            listTitle: 'Watch other meditations from this theme'
        },
        edit: {
            title: 'Edit Meditation',
            successMessage: 'Meditation Information has been updated',
            successMessageAvatar: 'Meditation image has been updated',
            errorMessageAvatar: 'Meditation image is required',
            errorMessageStartedAt:
                'You can`t plan meditation less than 10 min before the live stream should start',
            delete: {
                button: 'Delete Meditation',
                successMessage: 'The meditation has been deleted'
            },
            confirmation: {
                delete: {
                    title: 'Delete Meditation',
                    description:
                        'Are you sure you want to permanently delete this Meditation?'
                }
            },
            comingSoon: 'class is starting soon...',
            timer: {
                title: 'Your Session Starts In',
                minutes: 'Minutes',
                seconds: 'Seconds'
            }
        },
        general: {
            saveType: {
                evergreen: 'Evergreen',
                expiresOn: 'Expires On',
                replaceWith: 'Replace With'
            },
            upload: {
                button: 'Upload Picture'
            },
            audienceTypes: [
                {
                    label: 'Business',
                    value: 'business'
                },
                {
                    label: 'Personal',
                    value: 'personal'
                }
            ],
            audienceType: 'Audience type',
            subtitleSessionDetails: 'Meditation Details',
            subtitleDateAndTime: 'Date and Time',
            subtitleUploadVideo: 'Upload video',
            subtitleUploadPhoto: 'Upload Image',
            coverPhoto: 'Cover Image',
            subtitleSaveSettings: 'Save Settings',
            noResults: 'No results',
            status: {
                beforeMeditation: 'Before Meditation',
                afterMeditation: 'After Meditation'
            },
            button: {
                setMoodBefore: 'Set Your Mood',
                skipMood: 'Skip Mood Status'
            }
        },
        list: {
            title: 'Meditations',
            createButton: 'Live',
            createLiveRecordedButton: 'Live Recorded',
            createRecordedButton: 'Add Meditation',
            status: {
                planned: 'Planned',
                live: 'Upcoming Classes',
                recorded: 'Recorded',
                archived: 'Archived',
                locked: 'Locked',
                processing: 'Processing',
                checkin: 'CHILL Check-in'
            },
            reminderLabel: 'reminder set on,',
            posted: 'Posted',
            watched: 'Watched',
            joinMeditation: 'Join Meditation',
            watchMeditation: 'Watch Meditation',
            successMessage: 'Link has been Copied',
            errorMessage: 'Link was not created yet',
            copyStreamingLink: 'Copy Streaming Link',
            stopStreamingHint: 'Stop Streaming Video',
            copyStreamingLinkHint:
                'Use this link in your streaming <br /> software',
            editHint:
                'This option will be available 10 <br/> min before start of the session',
            forceStart: 'Force start'
        },
        tableHeaders: [
            { text: 'Meditation Name', value: 'title' },
            {
                text: 'Business Name ',
                value: 'businessId',
                sortable: false,
                filter: 'business'
            },
            {
                text: '',
                width: '40',
                sortable: false
            },
            {
                text: 'Status',
                value: 'type',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Planned',
                        value: 'planned'
                    },
                    {
                        title: 'Live Now',
                        value: 'live'
                    },
                    {
                        title: 'Recorded',
                        value: 'recorded'
                    },
                    {
                        title: 'Archived',
                        value: 'archived'
                    }
                ]
            },
            {
                text: 'Available On',
                sortable: false
            },
            {
                text: 'Available Until',
                sortable: false
            },
            { text: 'Actions', sortable: false, class: 'SessionActions' }
        ],
        codes: {
            errors: {
                SESSION_CHANNEL_ALREADY_PRESENT:
                    'Session already has a channel created',
                SESSION_TOO_MANY_CHANNELS_CREATED:
                    'Too many channels currently active, please contact tech support.',
                SESSION_TOO_MANY_INPUTS_CREATED:
                    'Too many inputs currently active, please contact tech support.'
            }
        }
    }
};
